var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        data: _vm.owners,
        "cell-class-name": "el-table-cell",
        "row-class-name": "el-table-row",
      },
    },
    [
      _c(
        "div",
        { staticClass: "empty", attrs: { slot: "empty" }, slot: "empty" },
        [
          _c("img", { attrs: { src: _vm.images.group_empty } }),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.nl2br(_vm.$t("Cuona.Event.description07"))),
            },
          }),
          _vm.edit == true
            ? [
                _c(
                  "el-button",
                  {
                    attrs: { type: "info", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openDialog")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Cuona.Group.set_group")))]
                ),
              ]
            : [
                _c(
                  "el-button",
                  {
                    attrs: { type: "info", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openCreateDialog")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Cuona.Group.set_group")))]
                ),
              ],
        ],
        2
      ),
      _c("el-table-column", {
        attrs: {
          width: "150px",
          prop: "humanized_id",
          label: _vm.$t("Owners.company.humanized_id"),
          sortable: "",
        },
      }),
      _c("el-table-column", {
        attrs: {
          width: "250px",
          prop: "name",
          label: _vm.$t("Owners.company.name"),
          sortable: "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("ruby", [
                  _vm._v(_vm._s(props.row.name)),
                  _c("rt", [_vm._v(_vm._s(props.row.name_kana))]),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm.edit == false
        ? [
            _c("el-table-column", {
              attrs: {
                width: "140px",
                prop: "type",
                label: _vm.$t("Owners.company.type"),
                sortable: "",
                align: "center",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.showType(props.row.type))),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                false,
                462100932
              ),
            }),
          ]
        : _vm._e(),
      _c("el-table-column", {
        attrs: {
          prop: "is_active",
          width: "110px",
          align: "center",
          label: _vm.$t("Owners.company.is_active"),
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.makeStatusCss(props.row.is_active),
                      size: "small",
                    },
                  },
                  [_vm._v(_vm._s(_vm.showStatus(props.row.is_active)))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "description", label: _vm.$t("Owners.company.note") },
      }),
      _c("el-table-column", {
        attrs: { width: "100px", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "owner",
                        params: { id: props.row.humanized_id },
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "setting el-icon-setting" }),
                    _vm._v(_vm._s(_vm.$t("Owners.company.detail"))),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }